import React from 'react';
import { useRegistration } from './RegistrationContext';
export const CallToAction = () => {
  const {
    openPopup
  } = useRegistration();
  return <section className="mb-10" data-id="element-28">
      <h2 className="text-xl font-bold text-blue-800 mb-4" data-id="element-29">
        Reserveer Nu Je Gratis Plek
      </h2>
      <div className="w-full mb-6" data-id="element-30">
        <button onClick={openPopup} className="w-full block" data-id="element-31">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/kmdhUzYLBMY9Kw3oqsxgTL/Scherm%C2%ADafbeelding_2025-08-15_om_15.56.55.png" alt="Vrouw communiceert met haar golden retriever in een gezellige woonkamer" className="w-full h-auto rounded-lg shadow-md hover:opacity-95 transition-opacity" data-id="element-32" />
        </button>
        <p className="text-xs text-gray-500 mt-1 text-center italic" data-id="element-33">
          Leer de hondentaal vanuit je eigen woonkamer tijdens ons gratis
          webinar
        </p>
      </div>
      <p className="mb-6 leading-relaxed" data-id="element-34">
        Sandra, met wie ik dit artikel begon, kwam ook naar een van mijn eerdere
        webinars. Vorige week stuurde ze me een foto van haarzelf en Benny,
        ontspannen lopend in hetzelfde park waar ze maanden geleden zo'n
        vervelende ervaring had.
      </p>
      <p className="mb-6 italic" data-id="element-35">
        "Amee," schreef ze, "ik kan niet geloven dat dit dezelfde hond is. Maar
        eigenlijk is hij helemaal niet veranderd - ik ben veranderd. Ik spreek
        nu zijn taal."
      </p>
      <p className="mb-6 leading-relaxed" data-id="element-36">
        Die transformatie is ook voor jou mogelijk. De verborgen taalbarrière
        tussen jou en je hond hoeft niet voor altijd te bestaan.
      </p>
      <div className="bg-red-50 p-3 rounded-lg mb-6 border-2 border-red-300" data-id="element-37">
        <p className="text-center font-bold text-red-700" data-id="element-38">
          ⚠️ LET OP: SLECHTS 75 PLAATSEN BESCHIKBAAR! ⚠️
        </p>
      </div>
      <button onClick={openPopup} className="block w-full" data-id="element-39">
        <div className="bg-blue-600 hover:bg-blue-700 text-white p-6 rounded-lg mb-8 border border-blue-700 transition-colors text-center" data-id="element-40">
          <h3 className="text-xl font-bold mb-2" data-id="element-41">
            RESERVEER NU JE GRATIS PLEK
          </h3>
          <p className="mb-4" data-id="element-42">Kies uit: 10:00, 13:00 of 20:00 uur</p>
          <div className="w-full bg-white text-blue-700 hover:bg-blue-50 font-bold py-4 px-4 rounded-lg transition duration-200 mb-4 animate-pulse" data-id="element-43">
            JA, IK WIL DEZE GRATIS TRAINING VOLGEN!
          </div>
          <p className="text-sm" data-id="element-44">
            Inclusief gratis werkboek & 48-uurs toegang tot de opname
          </p>
        </div>
      </button>
      <p className="mb-6 leading-relaxed" data-id="element-45">
        <span className="font-bold" data-id="element-46">Wacht niet te lang!</span> Vorige webinars
        waren binnen een paar uur volgeboekt. Reserveer nu je plek om
        teleurstelling te voorkomen.
      </p>
      <p className="font-semibold text-blue-800 text-center mb-6" data-id="element-47">
        <button onClick={openPopup} className="hover:underline" data-id="element-48">
          Je hond wacht al zijn hele leven op het moment dat jullie elkaar echt
          begrijpen. Dat moment begint met dit webinar.
        </button>
      </p>
    </section>;
};